import { render, staticRenderFns } from "./AAsignarCargoAdd.vue?vue&type=template&id=fa528bba"
import script from "./AAsignarCargoAdd.vue?vue&type=script&lang=js"
export * from "./AAsignarCargoAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports